import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '@app/auth.service';
import { UserService } from '@app/user.service';
import { map } from 'rxjs/operators';
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService,
    private router: Router,
    private user: UserService
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.auth.isLoggedIn) {
      return true;
    }

    const data = this.user.isLoggedIn();
    if (data.status) {
      this.auth.setLoggedIn(true);
      return true;
    } else {
      this.router.navigate(['login']);
      return false;
    }
    // return this.user.isLoggedIn().pipe(map(res => {
    //   if (res.status) {
    //     this.auth.setLoggedIn(true);
    //     return true;
    //   } else {
    //     console.log('logout');
    //     this.router.navigate(['login']);
    //     return false;
    //   }
    // }));
  }
}



// WEBPACK FOOTER //
// ./src/app/auth.guard.ts